import Image from "next/image";

interface FeatureProps {
  title: string;
  subtitle: string;
  imageSrc: string;
}

// const Feature = () => {
const Feature = ({ title, subtitle, imageSrc }: FeatureProps) => {
  return (
    <>
      <div className="flex flex-col gap-2 md:gap-8 items-center pt-10 z-20 md:mb-20 transition duration-500 ease-in-out transform hover:scale-105">
        <div className="relative w-full">
          <div className="min-h-[350px] sm:min-h-[425px] md:min-h-[500px] w-full">
            <Image
              src={`/how-it-works/${imageSrc}`}
              alt={`${title}`}
              priority
              objectFit="contain"
              layout="fill"
              className="z-20 w-full h-full object-contain drop-shadow-2xl"
            />
            <div
              className="absolute w-[40rem] h-[35rem] -right-[1rem] -bottom-[6rem] md:w-[45rem] md:h-[40rem] md:-right-[5rem] md:-bottom-[6rem] transform hover:scale-105"
              style={{
                background:
                  "radial-gradient(50% 50% at 50% 50%, #FE1FAC 0%, rgba(254, 31, 172, 0.00) 80%)",
              }}
            ></div>
          </div>
        </div>
        <h2 className="w-4/5 block text-2xl sm:text-3xl md:text-4xl 2xl:text-4xl font-semibold text-center">
          {title}
        </h2>
        <p className="w-4/5 block px-1 text-lg sm:text-2xl font-light text-center">
          {subtitle}
        </p>
      </div>
    </>
  );
};

export default Feature;
